import { CardWithText } from './CardWithText';

export default CardWithText;
